// extracted by mini-css-extract-plugin
module.exports = {"accordion":"AccordionSection_accordion__mDjry","title":"AccordionSection_title__FpeuW"};